import { Container } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled(Container)`
  &.flex {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
